import { apiJson } from '@/lib/api';
import type { PresignedUrlResponse } from '@/lib/types';

export const MAX_EXPENSE_ATTACHMENTS = 3;
export const MAX_EXPENSE_ATTACHMENT_BYTES = 10 * 1024 * 1024;

type GetToken = () => Promise<string | null>;

export function buildExpenseAttachmentFileName(file: File, index = 0): string {
  const extension = file.name.split('.').pop()?.toLowerCase() || 'jpg';
  return `attachment-${Date.now()}-${index}.${extension}`;
}

export async function uploadExpenseAttachment(
  getToken: GetToken,
  expenseId: number,
  file: File,
  index = 0
): Promise<void> {
  const fileName = buildExpenseAttachmentFileName(file, index);
  const contentType = file.type || 'application/octet-stream';
  const presignedResponse = await apiJson<PresignedUrlResponse>(
    getToken,
    `/v1/expenses/${expenseId}/attachments`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: fileName,
        attachment_type: contentType,
      }),
    }
  );

  const response = await fetch(presignedResponse.presigned_url, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });

  if (!response.ok) {
    const responseText = await response.text().catch(() => '');
    throw new Error(
      `Upload failed (${response.status}): ${
        responseText.substring(0, 200) || response.statusText
      }`
    );
  }
}
